import axios from 'axios';
import JustificationTemplate from '../domain/justification-template.entity';
import JustificationDetails from '../domain/justification-details.entity';
import Justify from '../domain/justify.entity';
import AddJustification from '../domain/add-justification.entity';
import { JustifyType } from '../domain/justify-type.enum';

export default class JustifyService {
  public static getJustificationsByType(type: JustifyType): Promise<Justify[]> {
    const params = { params: { type } };
    return axios.get('/api/v1/justifications', params)
      .then((response: any) => Justify.ofList(response.data));
  }

  public static getJustificationsByBusinessUnitAndType(
    businessUnitId: string,
    type: JustifyType,
  ): Promise<Justify[]> {
    const params = { params: { type } };
    return axios.get(`/api/v1/business-units/${businessUnitId}/justifications`, params)
      .then((response: any) => Justify.ofList(response.data));
  }

  public static getJustificationsByBusinessUnitAndTypeAndWithTemplate(
    businessUnitId: string,
    type: JustifyType,
  ): Promise<Justify[]> {
    const params = { params: { type } };
    return axios.get(`/api/v1/business-units/${businessUnitId}/justifications-with-template-email`, params)
      .then((response: any) => Justify.ofList(response.data));
  }

  public static getJustificationsIdsByBusinessUnitAndType(
    businessUnitId: string,
    type: JustifyType,
  ): Promise<string[]> {
    const params = { params: { type } };
    return axios.get(`/api/v1/business-units/${businessUnitId}/justifications/ids`, params)
      .then((response: any) => response.data);
  }

  public static addJustification(justification: AddJustification): Promise<void> {
    return axios.post('/api/v1/justifications', justification);
  }

  public static bindJustifications(
    businessUnitId: string,
    type: JustifyType,
    justifications: string[],
  ): Promise<void> {
    return axios.put(`/api/v1/business-units/${businessUnitId}/justifications?type=${type}`, justifications);
  }

  public static getJustificationTemplates(): Promise<JustificationTemplate[]> {
    return axios.get('/api/v1/justifications/templates')
      .then((response: any) => response.data.map((it) => new JustificationTemplate(it)));
  }

  public static getJustificationTemplateDetails(
    businessUnitId: string,
    templateId: string,
  ): Promise<JustificationDetails> {
    return axios.get(`/api/v1/business-units/${businessUnitId}/justifications/templates/${templateId}`)
      .then((response: any) => new JustificationDetails(response.data));
  }

  public static saveTemplateDetails(
    businessUnitId: string,
    details: JustificationDetails,
  ): Promise<void> {
    return axios.put(`/api/v1/business-units/${businessUnitId}/justifications/templates/${details.id}`, {
      boundEmails: details.boundEmails,
      boundJustificationIds: details.boundJustificationIds,
    });
  }

  public static getJustificationTemplate(
    businessUnitId: string,
    templateId: string,
    type: JustifyType,
  ): Promise<Justify[]> {
    const params = { params: { type } };
    const url = `/api/v1/business-units/${businessUnitId}/justifications/templates/${templateId}/selected`;
    return axios.get(url, params)
      .then((response: any) => Justify.ofList(response.data));
  }

  public static getJustificationTemplateUnbound(
    businessUnitId: string,
    templateId: string,
    type: JustifyType,
  ): Promise<Justify[]> {
    const params = { params: { type } };
    const url = `/api/v1/business-units/${businessUnitId}/justifications/templates/${templateId}/unbound`;
    return axios.get(url, params)
      .then((response: any) => Justify.ofList(response.data));
  }
}
